"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactOverlays = require("react-overlays");

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

var _InternalLink = _interopRequireDefault(require("./InternalLink"));

var _Paragraph = _interopRequireDefault(require("../TitlesAndTexts/Paragraph"));

var _ProfilePicture = _interopRequireDefault(require("../ImagesAndIcons/ProfilePicture"));

var _DropdownContainer = _interopRequireDefault(require("../Filters/DropdownContainer"));

var _DropdownToggle = _interopRequireDefault(require("../Filters/DropdownToggle"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const Nav = _styledComponents.default.nav.withConfig({
  displayName: "UserMenu__Nav",
  componentId: "design-system__sc-76hcjf-0"
})(["box-sizing:border-box;& > *{box-sizing:border-box;}& > ul{display:flex;list-style:none;margin:0;padding:0;}& > ul > li{flex:0 0 auto;color:#fff;transition-duration:0.5s;height:4.5rem;}& > ul > li:hover{background:#f9f9f9;}"]);

const StyledLink = _styledComponents.default.span.withConfig({
  displayName: "UserMenu__StyledLink",
  componentId: "design-system__sc-76hcjf-1"
})(["font-family:", ";font-size:", ";color:", ";text-transform:uppercase;cursor:pointer;text-decoration:none;display:flex;"], _BaseTheme.default.type.family.system, _BaseTheme.default.type.size.normal, _BaseTheme.default.colors.black);

const UserMenu = _ref => {
  let {
    imageUrl,
    email,
    logout
  } = _ref;

  if (!logout) {
    return /*#__PURE__*/_react.default.createElement(Nav, {
      role: "navigation"
    });
  }

  const [show, setShow] = (0, _react.useState)(false);
  return /*#__PURE__*/_react.default.createElement(Nav, {
    role: "navigation"
  }, /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_reactOverlays.Dropdown, {
    show: show,
    onToggle: nextShow => setShow(nextShow),
    drop: "down",
    alignEnd: true,
    itemSelector: "button:not(:disabled)"
  }, () => /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_DropdownToggle.default, null, /*#__PURE__*/_react.default.createElement(StyledLink, null, /*#__PURE__*/_react.default.createElement(_ProfilePicture.default, {
    imageUrl: imageUrl
  }))), /*#__PURE__*/_react.default.createElement(_DropdownContainer.default, null, /*#__PURE__*/_react.default.createElement(_Paragraph.default, null, email), /*#__PURE__*/_react.default.createElement(_InternalLink.default, {
    onClick: logout
  }, "Log out")))))));
};

UserMenu.propTypes = {
  email: _propTypes.default.string,
  imageUrl: _propTypes.default.string,
  logout: _propTypes.default.func
};
UserMenu.defaultProps = {
  email: undefined,
  imageUrl: 'https://api.adorable.io/avatars/40/abott@adorable.png',
  logout: undefined
};
var _default = UserMenu;
exports.default = _default;